import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_ORGANIZATION_NAME = gql`
  query fetchOrgName($id: String!) {
    fetchOrganization(organizationId: $id) {
      organization { translatedName { ${TRANSLATED_STRING_FIELDS} } }
    }
  }
`;
